import { Page } from '@/core/architecture'

import { GachaDetailTemplate } from './template'
import { useTemplateStore } from './template/templateStore'
import { useViewModel } from './viewModel'

/**
 * GachaDetail Page
 * Implemented as a practical sample.
 */
export const GachaDetail: Page = () => {
  const { state, actions } = useTemplateStore(useViewModel())

  return <GachaDetailTemplate state={state} {...actions} />
}
